import { useRef } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import TopImage from '/assets/images/top.svg';
import TopHoverImage from '/assets/images/top_hover.svg';

import { Nav } from '@web/app/shared/components/Nav';

export const PrivacyPage = () => {
    const { t } = useTranslation();
    const sectionRefs = useRef<React.RefObject<HTMLDivElement>[]>([]);
    if (sectionRefs.current.length !== 11) {
        sectionRefs.current = Array(11)
            .fill(null)
            .map(() => React.createRef<HTMLDivElement>());
    }

    const handleScrollToSection = (index: number) => {
        const headerHeight = 80;
        const sectionTop = sectionRefs.current[index].current?.getBoundingClientRect().top || 0;
        const offsetPosition = window.pageYOffset + sectionTop - headerHeight;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    };

    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const sections = [
        {
            title: t('privacy.title1.title'),
            content: [
                t('privacy.title1.desc'),
                {
                    subtitle: t('privacy.title1.subTitle1'),
                    text: t('privacy.title1.text1'),
                },
                {
                    subtitle: t('privacy.title1.subTitle2'),
                    text: t('privacy.title1.text2'),
                },
                {
                    subtitle: t('privacy.title1.subTitle3'),
                    text: t('privacy.title1.text3'),
                },
            ],
        },
        {
            title: t('privacy.title2.title'),
            content: [
                t('privacy.title2.desc'),
                {
                    subtitle: t('privacy.title2.subTitle1'),
                    text: t('privacy.title2.text1'),
                },
                {
                    subtitle: t('privacy.title2.subTitle2'),
                    text: t('privacy.title2.text2'),
                },
            ],
        },
        {
            title: t('privacy.title3.title'),
            content: [t('privacy.title3.desc')],
        },
        {
            title: t('privacy.title4.title'),
            content: [
                t('privacy.title4.desc'),
                {
                    subtitle: t('privacy.title4.subTitle1'),
                    text: t('privacy.title4.text1'),
                },
                {
                    subtitle: t('privacy.title4.subTitle2'),
                    text: t('privacy.title4.text2'),
                },
                {
                    subtitle: t('privacy.title4.subTitle3'),
                    text: t('privacy.title4.text3'),
                },
            ],
        },
        {
            title: t('privacy.title5.title'),
            content: [
                t('privacy.title5.desc'),
                {
                    subtitle: t('privacy.title5.subTitle1'),
                    text: t('privacy.title5.text1'),
                },
                {
                    subtitle: t('privacy.title5.subTitle2'),
                    text: t('privacy.title5.text2'),
                },
            ],
        },
        {
            title: t('privacy.title6.title'),
            content: [
                t('privacy.title6.desc'),
                {
                    subtitle: t('privacy.title6.subTitle1'),
                    text: t('privacy.title6.text1'),
                },
                {
                    subtitle: t('privacy.title6.subTitle2'),
                    text: t('privacy.title6.text2'),
                },
                {
                    subtitle: t('privacy.title6.subTitle3'),
                    text: t('privacy.title6.text3'),
                },
            ],
        },
        {
            title: t('privacy.title7.title'),
            content: [t('privacy.title7.desc')],
        },
        {
            title: t('privacy.title8.title'),
            content: [t('privacy.title8.desc')],
        },
        {
            title: t('privacy.title9.title'),
            content: [t('privacy.title9.desc')],
        },
        {
            title: t('privacy.title10.title'),
            content: [t('privacy.title10.desc')],
        },
        {
            title: t('privacy.title11.title'),
            content: [t('privacy.title11.desc')],
        },
    ];

    return (
        <>
            <Nav title={t('privacy.title')} />
            <div className="w-full bg-background pt-[50px] max-md:pt-0">
                <div className="sticky top-0 bg-background py-4 mb-3.5 text-center max-xs:py-1">
                    <span className="text-sub dark:text-sub-title text-[36px] font-semibold max-xs:hidden">
                        {t('privacy.title')}
                    </span>
                </div>
                <main className="px-4 text-base text-sub-title">
                    <div className="mb-8">{t('privacy.desc')}</div>
                    <div className="text-lg font-medium mb-4">{t('privacy.listTitle')}</div>
                    <ul className="inline-flex flex-col space-y-1 mb-8">
                        {sections.map((section, index) => (
                            <li
                                key={index}
                                onClick={() => handleScrollToSection(index)}
                                className="cursor-pointer underline hover:text-link"
                            >
                                {section.title}
                            </li>
                        ))}
                    </ul>
                    {sections.map((section, index) => (
                        <div key={index} ref={sectionRefs.current[index]} className="mb-8whitespace-pre-wrap">
                            <div className="text-2xl text-text mb-[11px] font-semibold max-md:text-lg">
                                {section.title}
                            </div>
                            {section.content.map((item, i) => (
                                <div key={i} className="mb-7 whitespace-pre-wrap">
                                    {typeof item === 'string' ? (
                                        item
                                    ) : (
                                        <>
                                            <div className="text-lg max-md:text-[16px] font-medium mb-2 text-text">
                                                {item.subtitle}
                                            </div>
                                            <div>{item.text}</div>
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                    ))}
                </main>
                <button
                    className="button-image !fixed bottom-[52px] right-[52px] max-md:bottom-6 max-md:right-[18px] group"
                    onClick={() => goToTop()}
                >
                    <img className="max-md:scale-[0.8387] cursor-pointer group-hover:hidden" src={TopImage} alt="" />
                    <img
                        className="max-md:scale-[0.8387] cursor-pointer hidden group-hover:block"
                        src={TopHoverImage}
                        alt=""
                    />
                </button>
            </div>
        </>
    );
};
